import { Component } from '@angular/core';

@Component({
  selector: 'app-foodprocessing',
  templateUrl: './foodprocessing.component.html',
  styleUrl: './foodprocessing.component.scss'
})
export class FoodprocessingComponent {

}
